export default () => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: 400,
        position: 'relative',
        width: '100%',
        '& > div': {
            flex: 1,
        },
    },
    fullscreen: {
        backgroundColor: '#1e1e1e',
        height: '100vh',
        padding: 24,
        width: '100vw',
    },
    fullscreenBtn: {
        cursor: 'pointer',
        position: 'absolute',
        right: 10,
        top: 10,
        transition: 'all 0.2s ease',
        zIndex: 1000,
        '&:hover': {
            opacity: 0.8,
        },
        '&:active': {
            transform: 'scale(0.95)',
        },
    },
});
